import { render, staticRenderFns } from "./home-organization-manager.vue?vue&type=template&id=754065bf&scoped=true"
var script = {}
import style0 from "./home-organization-manager.vue?vue&type=style&index=0&id=754065bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754065bf",
  null
  
)

export default component.exports